<template>
  <admin-layout :title="$t('Dashboard')">
    <div class="px-4 md:px-0">
      <tec-section-title class="-mx-4 md:mx-0 mb-6">
        <template #title>{{ $t('Dashboard') }}</template>
        <template #description>{{ $t('Please review the data in the chart below') }}</template>
      </tec-section-title>

      <div class="flex items-center gap-4 mb-2">
        <div class="w-1/2">
          <select-input v-model="month" :label="$t('Month')" @change="reload">
            <option v-for="month of months" :value="month.value" :key="'m_' + month.value">{{ $t(month.label) }}</option>
          </select-input>
        </div>

        <div class="w-1/2">
          <select-input v-model="year" :label="$t('Year')" @change="reload">
            <option v-for="year of years" :value="year.value" :key="'y_' + year.value">{{ year.label }}</option>
          </select-input>
        </div>

        <!-- <auto-complete v-model="month" :suggestions="months" class="w-1/2" @update:modelValue="reload" />
        <auto-complete v-model="year" :suggestions="years" class="w-1/2" @update:modelValue="reload" /> -->
      </div>

      <section class="my-4 mx-auto">
        <h2 class="mb-2 font-extrabold">{{ $monthName(year + '-' + month + '-01') }} {{ year }} (Month Totals)</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">{{ $currency(data?.total_tax) }}</h2>
              <!-- <span
                v-if="data.checkins != 0 && data.previous_checkins != 0"
                class="flex items-center space-x-1 text-sm font-medium leading-none"
                :class="data.checkins > data.previous_checkins ? 'text-green-500' : 'text-red-500'"
              >
                <icons v-if="data.checkins > data.previous_checkins" name="up" />
                <icons v-else name="down" />
                <span> {{ $number((data.checkins / data.previous_checkins) * 100 - 100) }}% </span>
              </span> -->
            </div>
            <p class="leading-none text-gray-600">{{ $t('Tax') }}</p>
          </div>
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">{{ $currency(data?.total_commission) }}</h2>
              <!-- <span
                v-if="data.checkouts != 0 && data.previous_checkouts != 0"
                class="flex items-center space-x-1 text-sm font-medium leading-none"
                :class="data.checkouts > data.previous_checkouts ? 'text-green-500' : 'text-red-500'"
              >
                <icons v-if="data.checkouts > data.previous_checkouts" name="up" />
                <icons v-else name="down" />
                <span> {{ $number((data.checkouts / data.previous_checkouts) * 100 - 100) }}% </span>
              </span> -->
            </div>
            <p class="leading-none text-gray-600">{{ $t('Commission') }}</p>
          </div>
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">{{ $currency(data?.total_agent_commission) }}</h2>
            </div>
            <p class="leading-none text-gray-600">{{ $t('Agent Commission') }}</p>
          </div>
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">{{ $currency(data?.grand_total) }}</h2>
            </div>
            <p class="leading-none text-gray-600">{{ $t('Grant Total') }}</p>
          </div>
        </div>
      </section>

      <section class="my-4 mx-auto">
        <h2 class="mb-2 font-extrabold">{{ year }} (Year Totals)</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">{{ $currency(year_data?.total_tax) }}</h2>
            </div>
            <p class="leading-none text-gray-600">{{ $t('Tax') }}</p>
          </div>
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">{{ $currency(year_data?.total_commission) }}</h2>
            </div>
            <p class="leading-none text-gray-600">{{ $t('Commission') }}</p>
          </div>
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">
                {{ $currency(year_data?.total_agent_commission) }}
              </h2>
            </div>
            <p class="leading-none text-gray-600">{{ $t('Agent Commission') }}</p>
          </div>
          <div class="p-4 rounded-md shadow bg-white">
            <div class="flex items-start justify-between">
              <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">{{ $currency(year_data?.grand_total) }}</h2>
            </div>
            <p class="leading-none text-gray-600">{{ $t('Grant Total') }}</p>
          </div>
        </div>
      </section>

      <div class="mt-4 rounded-md border overflow-hidden">
        <vue-highcharts
          type="chart"
          :options="radialChartData"
          :redrawOnUpdate="true"
          :oneToOneUpdate="false"
          :animateOnUpdate="true"
          style="min-width: 550px"
        />
      </div>
      <div class="mt-4 bg-white rounded-md shadow overflow-x-auto">
        <vue-highcharts
          type="chart"
          :options="barChartData"
          :redrawOnUpdate="true"
          :oneToOneUpdate="false"
          :animateOnUpdate="true"
          style="min-width: 550px"
        />
      </div>
    </div>
  </admin-layout>
</template>

<script>
import VueHighcharts from 'vue3-highcharts';
import AdminLayout from '@/Layouts/AdminLayout.vue';
// import AutoComplete from '@/Shared/AutoComplete.vue';
import SelectInput from '@/Shared/SelectInput';
import TecSectionTitle from '@/Jetstream/SectionTitle.vue';

export default {
  props: ['data', 'chart', 'year_data'],

  components: { AdminLayout, VueHighcharts, SelectInput, TecSectionTitle },

  data() {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      months: [
        { label: this.$monthName('2022-01-01'), value: 1 },
        { label: this.$monthName('2022-02-01'), value: 2 },
        { label: this.$monthName('2022-03-01'), value: 3 },
        { label: this.$monthName('2022-04-01'), value: 4 },
        { label: this.$monthName('2022-05-01'), value: 5 },
        { label: this.$monthName('2022-06-01'), value: 6 },
        { label: this.$monthName('2022-07-01'), value: 7 },
        { label: this.$monthName('2022-08-01'), value: 8 },
        { label: this.$monthName('2022-09-01'), value: 9 },
        { label: this.$monthName('2022-10-01'), value: 10 },
        { label: this.$monthName('2022-11-01'), value: 11 },
        { label: this.$monthName('2022-12-01'), value: 12 },
      ],
      monthData: {},
      yearData: {},
    };
  },

  computed: {
    years() {
      let years = [];
      let date = new Date();
      let year = date.getFullYear();
      for (let y = 2013; y <= year; y++) {
        years.push({ label: y + '', value: y + '' });
      }
      return years;
    },
    barChartData() {
      return this.barChartOptions();
    },
    radialChartData() {
      return this.radialChartOptions();
    },
  },

  //   watch: {
  //     month: function (m) {
  //       this.reload();
  //     },
  //     year: function (y) {
  //       this.reload();
  //     },
  //   },

  created() {
    let params = new URLSearchParams(this.$page.url.substring(1));
    if (params.get('month') && params.get('year')) {
      this.year = params.get('year');
      this.month = params.get('month');
    }

    // Month chart
    let keys = Object.keys(this.chart.month).sort();
    let total_tax = [];
    let total_commission = [];
    let grand_total = [];
    let total_agent_commission = [];
    for (const key in keys) {
      total_tax.push(this.chart.month[keys[key]].total_tax);
      total_commission.push(this.chart.month[keys[key]].total_commission);
      grand_total.push(this.chart.month[keys[key]].grand_total);
      total_agent_commission.push(this.chart.month[keys[key]].total_agent_commission);
    }
    this.monthData = { total_tax, grand_total, total_commission, total_agent_commission };

    // Year chart
    let y_keys = Object.keys(this.chart.year).sort();
    let y_total_tax = [];
    let y_total_commission = [];
    let y_grand_total = [];
    let y_total_agent_commission = [];
    for (const key in y_keys) {
      y_total_tax.push(this.chart.year[y_keys[key]].total_tax);
      y_total_commission.push(this.chart.year[y_keys[key]].total_commission);
      y_grand_total.push(this.chart.year[y_keys[key]].grand_total);
      y_total_agent_commission.push(this.chart.year[y_keys[key]].total_agent_commission);
    }
    this.yearData = {
      total_tax: y_total_tax,
      grand_total: y_grand_total,
      total_commission: y_total_commission,
      total_agent_commission: y_total_agent_commission,
    };
  },

  methods: {
    reload() {
      this.$inertia.visit(route('dashboard', { month: +this.month, year: +this.year }), { preserveState: false, preserveScroll: false });
    },
    sortValues(data) {
      return Object.values(
        Object.keys(data)
          .sort()
          .reduce((obj, key) => {
            obj[key] = data[key];
            return obj;
          }, {})
      );
    },
    onRender() {
      console.log('Chart rendered');
    },
    onUpdate() {
      console.log('Chart updated');
    },
    onDestroy() {
      console.log('Chart destroyed');
    },

    radialChartOptions() {
      return {
        chart: {
          zoomType: 'xy',
          spacingTop: 20,
          style: { fontFamily: 'Nunito' },
        },
        credits: {
          enabled: false,
        },
        title: {
          text: this.$t('Month Overview'),
          style: { fontWeight: 'bold', paddingTop: '10px' },
        },
        subtitle: {
          text: this.$t('Please review the chart below'),
        },
        colors: ['#059669', '#D97706', '#4F46E5', '#DC2626'],
        xAxis: [
          {
            // categories: this.$dateDay(Object.keys(this.chart.month.checkin)),
            categories: Object.keys(this.chart.month)
              .sort()
              .map(d => this.$date(d)),
            crosshair: true,
          },
        ],
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
        },
        tooltip: {
          shared: true,
          shadow: false,
          useHTML: true,
          borderRadius: '5',
          borderColor: '#1F2937',
          style: { color: '#fff' },
          backgroundColor: '#1F2937',
        },
        series: [
          {
            type: 'spline',
            name: this.$t('Tax'),
            data: this.monthData.total_tax,
            // data: this.sortValues(this.chart.month.tax),
          },
          {
            type: 'spline',
            name: this.$t('Agent Comm.'),
            data: this.monthData.total_agent_commission,
          },
          {
            type: 'spline',
            name: this.$t('Commission'),
            data: this.monthData.total_commission,
          },
          {
            type: 'spline',
            name: this.$t('Grand Total'),
            data: this.monthData.grand_total,
          },
        ],
      };
    },
    barChartOptions() {
      return {
        chart: {
          type: 'column',
          spacingTop: 20,
          style: { fontFamily: 'Nunito' },
        },
        credits: {
          enabled: false,
        },
        title: {
          text: this.$t('Year Overview'),
          style: { fontWeight: 'bold', paddingTop: '10px' },
        },
        subtitle: {
          text: this.$t('Please review the chart below'),
        },
        colors: ['#059669', '#D97706', '#4F46E5', '#DC2626'],
        xAxis: {
          // categories: this.months,
          categories: Object.keys(this.chart.year)
            .sort()
            .map(d => this.$month(d)),
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
        },
        tooltip: {
          // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          // pointFormat:
          //   '<tr><td style="color:{series.color};padding:3px;">{series.name}: </td>' +
          //   '<td style="text-align:right;padding:3px 3px 3px 10px;"><b>{point.y:.2f} mm</b></td></tr>',
          // footerFormat: '</table>',
          shared: true,
          shadow: false,
          useHTML: true,
          borderRadius: '5',
          borderColor: '#1F2937',
          style: { color: '#fff' },
          backgroundColor: '#1F2937',
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: this.$t('Tax'),
            data: this.yearData.total_tax,
          },
          {
            name: this.$t('Agent Comm.'),
            data: this.yearData.total_agent_commission,
          },
          {
            name: this.$t('Commission'),
            data: this.yearData.total_commission,
          },
          {
            name: this.$t('Grand Total'),
            data: this.yearData.grand_total,
          },
        ],
      };
    },
  },
};
</script>
